import { ThemeProperties } from '../../core';

export interface DividerTheme {
	baseBackground: string;
}

export const theme = new ThemeProperties('divider');
